// extracted by mini-css-extract-plugin
export default {"PreviewContainer":"ImagePreview_PreviewContainer__5tRsr","EditContainer":"ImagePreview_EditContainer__8-4fh"};